import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  forSaleWigsDetails: {},
  isLoading: false,
  showDialog: false,
};

//STORE SLICE
export const forSaleWigsDetailsSlice = createSlice({
  name: "forSaleWigsDetailsSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showForSaleWigsDetailsDialog(state, action) {
      return {
        ...state,
        showDialog: true,
        forSaleWigsDetails: action.payload,
      };
    },
    closeForSaleWigsDetailsDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showForSaleWigsDetailsDialog,
  closeForSaleWigsDetailsDialog,
  showLoading,
  hideLoading
} = forSaleWigsDetailsSlice.actions;

export default forSaleWigsDetailsSlice.reducer;
